<template>
  <section >

        <div class="header bg-gradient-success pb-6 pb-8 pt-5 pt-md-8">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row">
              <h4 class="profile-section-title">نوع کسب و کار را انتخاب نمائید :</h4>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid mt--7">
      <div class="card card-stats" show-footer-line="true">
        <!---->
        <div class="card-body dashboard-top-status">
    <div class="" v-if="!isEditMode">
      <div class="row close-bottom">
        <div class="col-md-11"></div>
        <div class="col-md-1">
          <router-link to="/profile/dashboard">
            <div title="بازگشت به داشبورد" class="close"></div>
          </router-link>
        </div>
      </div>
      <div class="card">
        <div class="row cardContent">
          <div style="width: 40%">
            <label>نوع کسب و کار را انتخاب نمائید :</label>
          </div>

          <div style="width: 50%" class="styled-select select">
            <select v-model="selected" @change="onChange($event)">
              <option
                v-for="item in businessType"
                :value="item.key"
                :key="item.key"
              >
                {{ item.value }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <agencyStepper v-if="selected == 1" />
    <companyStepper v-if="selected == 2" />
        </div>
      </div>
    </div>


  </section>
</template>

<script>
import agencyStepper from "./AgencyStepper";
import companyStepper from "./CompanyStepper";

export default {
  name: "Business",
  components: { agencyStepper, companyStepper },

  data() {
    return {
      businessType: [
        { key: 1, value: "آژانس" },
        { key: 2, value: " شرکت یا سازمان دولتی یا موسسه" },
      ],
      selected: 1,
      showSelected: true,
      sourceId: "",
      sourceProfileId:"",
      type: "",
      isEditMode: false,
    };
  },
  created() {
    this.sourceId = this.$route.params.sourceId;
    this.sourceProfileId = this.$route.params.sourceProfileId;
    this.type = this.$route.params.sourceType;

    if (this.sourceId != undefined) {
      if (this.type == 1) this.selected = 1;
      else this.selected = 2;
      this.isEditMode = true;
    }
  },

  methods: {
    onChange: function (event) {
      this.selected = event.target.value;
    },
  },
};
</script>

<style scoped>
.select {
  background-color: white !important;
  outline: auto !important;
  width: 35%;
  color: #ced4da !important;
}
.styled-select select {
  padding: 7px 5px 10px 5px;
  width: 100%;
  color: #333;
  border: 0 !important;
  border-radius: 0 !important;
}
.card {
  /* background-color: #f9f9f9; */
  margin: 5px 0px 20px 0px;
}
.cardContent {
  margin: 15px;
  text-align: center;
  margin: 20px 0px 0px 0px;
}
.lbl-font {
  font-size: 14px;
  margin-top: 5px;
}
.styled-select {
  background: #ffffff url(../../../public/img/down_arrow_select.png) no-repeat
    left center !important;
}
</style>